import { Card } from '@mui/material';

import { useParams } from 'react-router';
import { useSelectedPerson } from '../../context/StaffContext/StaffProvider';
// import { StaffTableLink } from 'ft-shared-graphql';

type RouteParams = {
    id?: string
}

type ActionOnCallback = () => void;
interface PersonTableLinkProps {
    onBack: ActionOnCallback
}

const PersonTableLink = ({
    onBack
}: PersonTableLinkProps) => {
    const routeParams = useParams<RouteParams>();
    // const locations = usePersonStore(state => state.locations)
    const { person } = useSelectedPerson(routeParams.id);


    return (
        <Card elevation={4} style={{
            width: "100%",
            height: "auto",
        }}>
            {/* <StaffTableLink onBack={onBack} person={person} /> */}
        </Card>
    )
}


export default PersonTableLink;